export default __webpack_public_path__ + "static/media/green.65148ab2.png";